import { render, staticRenderFns } from "./SummaryAllSoldProduct.vue?vue&type=template&id=3de754c6&"
import script from "./SummaryAllSoldProduct.vue?vue&type=script&lang=js&"
export * from "./SummaryAllSoldProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports